<template><div></div></template>

<script>
export default {
  name: "GoogleOAuthHandling",
  created() {
    if (this.$route.query.token) {
      sessionStorage.setItem("token", this.$route.query.token);
    }
    this.$router.push("/login");
  },
};
</script>
